module.exports = __webpack_public_path__ + "static/media/section6-illustration-min.961347ff.png";